import { AccountType } from '../investor';

export enum BackgroundExportStatus {
  Failed = 'FAILED',
  NoData = 'NO_DATA',
  Pending = 'PENDING',
  Completed = 'COMPLETED',
}

export enum BackgroundExportTypes {
  CashTransactionsReport = 'CASH_TRANSACTIONS_REPORT',
  InvestorSiteCashTransactionsReport = 'INVESTOR_SITE_CASH_TRANSACTIONS_REPORT',
  InvestmentTransactionsReport = 'INVESTMENT_TRANSACTIONS_REPORT',
  InvestorSiteInvestmentTransactionsReport = 'INVESTOR_SITE_INVESTMENT_TRANSACTIONS_REPORT',
  InvestmentHoldingsReport = 'INVESTMENT_HOLDINGS_REPORT',
  InvestmentExport = 'INVESTMENTS_EXPORT',
  ExitsExport = 'EXITS_EXPORT',
  AdviserStatementExport = 'ADVISER_STATEMENT_EXPORT',
  AdviserStatementExportAllFirms = 'ADVISER_STATEMENT_EXPORT_ALL_FIRMS',
  OrganisationStatementExport = 'ORGANISATION_STATEMENT_EXPORT',
  InvestorExport = 'INVESTOR_EXPORT',
  FeesExport = 'FEES_EXPORT',
  EisTasklistExport = 'EIS_TASKLIST_EXPORT',
  CompaniesExport = 'COMPANIES_EXPORT',
  AdvisersExport = 'ADVISERS_EXPORT',
  OrganisationsExport = 'ORGANISATIONS_EXPORT',
  BillingExport = 'BILLING_EXPORT',
  PortalUsageDataReport = 'PORTAL_USAGE_DATA_REPORT',
}

export interface CashTransaction {
  firstName?: string;
  lastName?: string;
  accountType: AccountType;
  registeredName?: string;
  date: Date;
  type: string;
  company?: {
    isVCT?: boolean;
    firm?: {
      firmName?: string;
    };
    fund?: {
      fundName?: string;
    };
    tradingName?: string;
    legalName?: string;
  } | null;
  investment?: {
    fund?: {
      fundName?: string;
    };
    investmentDate?: Date | null;
  } | null;
  moneyIn: number | null;
  moneyOut: number | null;
  notes: string | null;
  recipientFullName?: string;
  fullName: string;
  email: string;
  sourceInvestmentId?: string;
  destinationInvestmentId?: string;
  investorTag?: string;
}

export interface InvestmentTransaction {
  investmentId?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  fundName?: string;
  externalInvestmentId?: string | null;
  date?: Date | null;
  currency: string;
  shareClass?: string | null;
  type: string;
  numberOfShares?: number;
  fundsInOut?: number;
  description?: string | null;
  investorTag?: string;
  subscriptionTag?: string;
}

export interface InvestmentHolding {
  firstName?: string;
  lastName?: string;
  registeredName?: string;
  email: string;
  fundName: string;
  externalSubscriptionId: string;
  purchaseDate: Date;
  shareClass?: string | null;
  currency: string;
  company?: string | null;
  sharesHeld: number;
  capitalAllocated: number;
  sharesPurchased: number;
  saleValue: number;
  sharesSold: number;
  holdValue: number;
  initialSharePrice: number;
  currentSharePrice: number;
  investorTag?: string;
  subscriptionTag?: string;
}

export interface PortalUsageDataRow {
  name: string;
  email: string;
  portalAccessDate: Date;
  portalAccessTime: Date;
}
